import styled from "styled-components";

export const Container = styled.div`
    padding: 15px;
    background-color: ${props=> props.theme.colors.danger};
    color: ${props => props.theme.textColor.danger};
    border-left: 6px solid #b54c37;
    width: 100%;
`;